import { render, staticRenderFns } from "./CopyToClipboardExample.vue?vue&type=template&id=8f503924"
import script from "./CopyToClipboardExample.vue?vue&type=script&lang=js"
export * from "./CopyToClipboardExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports